var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh-ccw-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M1.66602 8.33333C1.66602 8.33333 1.76712 7.62563 4.69605 4.6967C7.62498 1.76777 12.3737 1.76777 15.3026 4.6967C16.3404 5.73443 17.0104 7.0006 17.3128 8.33333M1.66602 8.33333V3.33333M1.66602 8.33333H6.66602M18.3327 11.6667C18.3327 11.6667 18.2316 12.3744 15.3026 15.3033C12.3737 18.2322 7.62498 18.2322 4.69605 15.3033C3.65832 14.2656 2.98826 12.9994 2.68587 11.6667M18.3327 11.6667V16.6667M18.3327 11.6667H13.3327",
    stroke: "#0031DD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.c0c7f8fa01abc0963f29c3ffa0bdc5b0.svg";
export { ForwardRef as ReactComponent };